import logo from "../assets/img/logo.png";
import logoWhite from "../assets/img/logo-white.png";
import { Link } from "react-router-dom";

export default function LogoWithHomeLink() {
  return (
    <div className="w-full max-w-md pt-5 mx-auto sm:py-10">
      <Link
        to="/"
        className="inline-flex items-center text-sm text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
      >
        <img src={logo} alt="Logo" className="block dark:hidden" />
        <img src={logoWhite} alt="Logo" className="hidden dark:block" />
      </Link>
    </div>
  );
}
